import edit_button from '../edit_button.html';

export default function (nga, admin) {
	var devices = admin.getEntity('usermac')
	devices.listView()
		.title('<h4>Devices <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>')
		.batchActions([
            '<sendpush type="SOFTWARE_INSTALL" selection="selection"></sendpush>',
			'<sendpush type="deletedata" selection="selection"></sendpush>',
			'<sendpush type="deletesharedpreferences" selection="selection"></sendpush>'
        ])
		.actions(['batch', 'export', 'filter'])
		.fields([
			nga.field('id')
				.label('ID'),
			nga.field('username')
				.label('Username'),
			nga.field('device_mac_address', 'string')
				.label('Mac Address')
				.map(function (value, entry) {
					if(value == null || value == ""){
						return entry['device_id'];
					}
					return entry['device_mac_address'];
                }),
			nga.field('device_id', 'string')
				.label('Device ID'),
			nga.field('device_active', 'boolean')
				.label('Device Active'),
		])
		.filters([
			nga.field('q')
				.label('')
				.template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
				.pinned(true),
				nga.field('device_mac_address', 'string')
					.attributes({ placeholder: 'mac Id' })
					.label('MacId'),
				nga.field('device_active', 'boolean')
					.filterChoices([
						{ value: true, label: 'Active' },
						{ value: false, label: 'Not Active' }
					])
					.label('Device Active'),
				nga.field('username')
					.attributes({ placeholder: 'Username' })
					.label('Username'),
        ])
        .sortField('appid')
        .sortDir('ASC')
		.exportFields([
			devices.listView().fields(),
        ]);

	devices.creationView()
		.title('<h4>Devices <i class="fa fa-angle-right" aria-hidden="true"></i> Create: Device</h4>')
		.fields([
			nga.field('username')
				.attributes({ placeholder: 'Username' })
				.validation({ required: true })
				.editable(false)
				.label('Username'),
			nga.field('googleappid', 'string')
				.editable(false)
				.attributes({ placeholder: 'Google App Id' })
				.label('Google App ID'),
			nga.field('device_active', 'boolean')
				.validation({ required: true })
				.label('Device Active'),
			nga.field('device_mac_address', 'string')
				.attributes({ placeholder: 'Device Mac Address' })
				.validation({ required: true })
				.editable(false)
				.label('Device Mac Address'),
			nga.field('device_wifimac_address', 'string')
				.attributes({ placeholder: 'Device Wifi Mac Address' })
				.validation({ required: true })
				.editable(false)
				.label('Device Wifi Mac Address'),
			nga.field('device_ip', 'string')
				.attributes({ placeholder: 'Device IP' })
				.validation({ required: true })
				.editable(false)
				.label('Device IP'),
            nga.field('city', 'string')
                .attributes({ placeholder: 'City' })
                .validation({ required: true })
                .editable(false)
                .label('City'),
			nga.field('device_id', 'string')
				.attributes({ placeholder: 'Device ID' })
				.validation({ required: true })
				.editable(false)
				.label('Device ID'),
			nga.field('ntype', 'string')
				.attributes({ placeholder: 'Ntype' })
				.validation({ required: true })
				.editable(false)
				.label('Ntype'),
			nga.field('appid', 'string')
				.attributes({ placeholder: 'App ID' })
				.validation({ required: true })
				.editable(false)
				.label('App ID'),
			nga.field('api_version', 'string')
				.attributes({ placeholder: 'Api Version' })
				.validation({ required: true })
				.editable(false)
				.label('Api Version'),
			nga.field('firmware', 'string')
				.editable(false)
				.label('Firmware'),
			nga.field('os')
				.editable(false)
				.label('Os'),
			nga.field('screen_resolution')
				.editable(false)
				.label('Screen Resolution'),
			nga.field('hdmi')
				.editable(false)
				.label('HDMI'),
			nga.field('device_brand')
				.editable(false)
				.label('Device Brand'),
			nga.field('app_version', 'string')
				.editable(false)
				.validation({ required: true })
				.label('App Version'),
			nga.field('createdAt', 'datetime')
				.editable(false)
				.label('First Login'),
			nga.field('updatedAt', 'datetime')
				.editable(false)
				.label('Last Login'),
            nga.field('template')
				.label('')
				.template(edit_button),
		])

    devices.editionView()
		.title('<h4>Devices <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.username }}</h4>')
		.actions(['list'])
		.fields([
			devices.creationView().fields(),
        ]);
		
	return devices;
}



// WEBPACK FOOTER //
// ./js/usermac/config.js